import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    boxCode: {
      justifyContent: 'space-evenly',
    },
    codeInput: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
    },
    codeLabel: {
      marginBottom: 16,
      fontSize: 14,
      fontWeight: 'bold',
    },
    codeInputs: {
      display: 'flex',
      justifyContent: 'start',
      alignItems: 'center',
      '& input': {
        backgroundColor: 'transparent',
        textAlign: 'center',
        height: 60,
        width: 40,
        borderRadius: 10,
        margin: '0 4px',
        border: 'none',
        fontSize: 38,
        '&:focus': {
          outline: 'none',
        },
        '&:nth-of-type(3n)': {
          marginRight: 24,
        },
      },
    },
    textField: {
      width: 40,
      height: 60,
      textAlign: 'center',
      fontSize: 38,
      margin: '0 4px',
      borderRadius: 10,
      '& .MuiInputBase-root': {
        height: '100%',
        padding: 0,
        borderRadius: 10,
        borderColor: palette.gray,
      },
      '& input': {
        padding: '0 !important',
      },
    },
    textFieldSuperAdmin: {
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: palette.deepBlue,
      },
    },
    textFieldCompleteSuperAdmin: {
      '& .MuiInputBase-root': {
        borderColor: palette.deepBlue,
        color: palette.deepBlue,
        border: `0.5px solid ${palette.deepBlue}`,
      },
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: palette.deepBlue,
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: palette.transparent,
      },
    },
    retryText: {
      marginTop: 8,
      fontSize: 11,
      color: palette.sideGray,
    },
    retryTextButton: {
      fontSize: 11,
      color: palette.blue,
      marginLeft: 4,
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline',
        opacity: 0.7,
      },
    },
    retryTextButtonDisabled: {
      fontSize: 11,
      color: palette.sideGray,
      marginLeft: 4,
      cursor: 'default',
    },
    titleDescription: { marginBottom: 6, fontSize: 12 },
    helpDescription: { marginBottom: 6, fontSize: 11 },
    howToOptimize: {
      borderRadius: 25,
      backgroundColor: palette.backgroundBlue,
      color: palette.blue,
      fontSize: 10,
      '&:hover': {
        backgroundColor: palette.backgroundBlue,
      },
      '& .MuiButton-startIcon': {
        display: 'inherit',
        marginLeft: -4,
        marginRight: 4,
      },
    },
    helpIcon: { width: '16px !important', height: '16px !important' },
    helpGrid: {
      marginTop: 8,
      borderLeft: `4px solid ${palette.blue}`,
      paddingLeft: 8,
      boxShadow:
        'rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px',
      borderRadius: 4,
      paddingRight: 8,
    },
    helpButton: { marginTop: 16 },
    footerItems: {
      borderTop: `1px solid ${palette.borderGray}`,
      alignItems: 'center',
      justifyContent: 'flex-end',
      marginTop: 8,
      paddingTop: 8,
    },
  });
